/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Monatshinzurechnungsbetrag1Inputs */



/**

* @param {_Field_Monatshinzurechnungsbetrag1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_monatshinzurechnungsbetrag1 = /** @type {((inputs?: _Field_Monatshinzurechnungsbetrag1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Monatshinzurechnungsbetrag1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Monatshinzurechnungsbetrag")
});
export { _field_monatshinzurechnungsbetrag1 as "_field_monatsHinzurechnungsbetrag" }